<script>
import MainTable from '@/components/logs-managment/index/MainTable';
import FilterBox from '@/components/shared/FilterBox';
import { useChatsStore } from '@/v2/modules/whatsapp/stores/chats';

export default {
	components: { MainTable, FilterBox },
	props: {
		tenant: null,
		locale: null,
	},
	data() {
		return {
			activeFilters: {},
			langLoaded: false,
			marketPlaces: [],
			pageSettings: {},
			authed: false,
		};
	},
	computed: {
		filters() {
			return [
				{
					type: 'select',
					label: this.$t('marketPlaces'), // This now reacts to locale changes
					name: 'marketplace',
					options: [],
					settings: {
						ajax: {
							url: `${window.location.origin}/api/resources/marketplaces`,
							dataType: 'json',
						},
					},
				},
			];
		},
	},
	async mounted() {
		const chatsStore = useChatsStore();
		chatsStore.authenticateWithFirebase().then(() => {
			this.authed = true;
		});
		this.$i18n.locale = this.locale;
		if (this.$i18n.locale == 'en') {
			localStorage.setItem('lang', 'en');
		} else {
			localStorage.setItem('lang', 'ar');
		}

		// this.setFilters();
	},
	watch: {
		locale() {},
	},
	methods: {
		loadSvg(fileName) {
			return window.location.origin + '/assets/image/' + fileName;
		},
		handleFilterApply(filters) {
			console.log(filters);
			this.activeFilters = filters;
		},
	},
};
</script>

<template>
	<div id="kt_content_container" class="d-flex flex-column-fluid align-items-start container-xxl">
		<div class="content flex-row-fluid" id="kt_content">
			<div id="kt_toolbar_container">
				<filter-box class="filters" :filters="filters" @apply="handleFilterApply"></filter-box>
			</div>
			<div class="card mt-2">
				<div class="card-body" id="kt_table_data_wrapper">
					<main-table
						v-if="authed"
						:locale="locale"
						:tenant="tenant"
						:filters="activeFilters"
						:marketplace-id="selectedMarketplace"
					></main-table>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
.price-edit-btn-icon {
	margin: 5px;
}

.card-header .btn {
	margin: 10px 0px;
}

@media (max-width: 1375px) {
	.card-header .btn {
		margin: 10px 0px;
		height: 100%;
	}
}

@media (max-width: 767px) {
	.card-header .btn {
		margin: 10px 0px;
		height: 90%;
	}
}
</style>

<style scoped lang="scss">
.filters ::v-deep(.menu) {
	width: 300px !important;
}
</style>
